import { Button, ButtonProps } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { Pause, Play } from "lucide-react";

interface PlayButton extends ButtonProps {
  isPlaying: boolean;
}

export default function PlayButton({
  className,
  isPlaying,
  ...props
}: PlayButton) {
  return (
    <Button
      size={"icon"}
      variant={"outline"}
      className={cn(
        "flex h-10 w-10 items-center justify-center rounded-full border-[#C6BDA5B2]/70 bg-transparent transition-all duration-150 ease-in hover:border-secondary/90 md:h-14 md:w-14",
        className,
      )}
      {...props}
    >
      {isPlaying ? (
        <Pause className="h-6 w-6 xl:h-8 xl:w-8" />
      ) : (
        // Play icon (original path)
        <Play className="h-6 w-6 xl:h-8 xl:w-8" />
      )}
    </Button>
  );
}
